import Columns from 'components/Columns';
import { Heading, P, Section, Wrapper } from 'components/base';
import PropTypes from 'prop-types';
import React from 'react';
import V01 from 'svgs/events/sme/v01.svg';
import V02 from 'svgs/events/sme/v02.svg';
import V03 from 'svgs/events/sme/v03.svg';
import CTAButton from '../CTAButton';
import { itemContent, itemHeading, itemIcon, itemWrapper, v01, v02, v03, videoHeading, videoLi, videoLists, videoSection, videoWrapper } from './Features.module.scss';

const Item = ({ heading, list }) => (
  <div >
    <h2 className={itemHeading}>{heading}</h2>
    <ul>
      {
        list.map( (item, i) => (
          <li key={i} className={itemWrapper}>
            <div className={itemIcon}><img src={item.img.publicURL} alt={item.text} /></div>
            <P size="L" className={itemContent}>{item.text}</P>
          </li>
        ) )
      }
    </ul>
  </div>
);
Item.propTypes = {
  heading: PropTypes.string,
  list: PropTypes.array,
};

const Features = ({ features, videos }) => (
  <>
    <Section id="feature">
      <Wrapper>
        <Heading Tag="h1" size="L" marginBottom="M" center bold>{features.heading}</Heading>
        <Columns items={features.content} Item={Item} columnCount={3} />
        <div className="align-item-center mt-l">
          <CTAButton url="https://app.newsleopard.com/auth/signup?utm_source=SMEcampaignpage&utm_medium=middleCTA&utm_campaign=2021newuser" />
        </div>
      </Wrapper>
    </Section>
    <Section className={videoSection} padding="Xl">
      <Wrapper size="L">
        <Heading className={videoHeading} Tag="h1" size="L" marginBottom="M" center>{videos.heading}</Heading>
        <ul className={videoLists}>
          {videos.url.map((item, i) => 
            <li key={i} className={videoLi}>
              <div className={videoWrapper}>
                <iframe width="560" height="315" src={item} title="Newsleopard" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
              </div>
            </li>
          )}
        </ul>
      </Wrapper>
      <V01 className={v01} /><V02 className={v02} /><V03 className={v03} />
    </Section>
  </>
);

Features.propTypes = {
  features: PropTypes.object.isRequired,
  videos: PropTypes.object.isRequired,
};

export default Features;